const materialBaseURL = '/zohoForms';
const getData = R.prop('data');

function getUUID() {
    return axios.get(`${materialBaseURL}/generate`).then(getData);
}

function getInvoiceData(uuid) {
    return axios.get(`${materialBaseURL}/${uuid}`).then(getData);
}

function pay(uuid) {
    return axios.post(`${materialBaseURL}/${uuid}/pay`).then(getData);
}

export default { getUUID, getInvoiceData, pay };
